import { Component, OnInit } from '@angular/core';
import { CourseService } from '@scaffold/services/course.service';
import { Title } from '@angular/platform-browser';
import { UserService } from '@services/user.service';
import { take } from 'rxjs/operators';

@Component({
    selector: 'app-landing-page',
    templateUrl: './landing-page.component.html',
    styleUrls: ['./landing-page.component.scss'],
    standalone: false
})
export class LandingPageComponent implements OnInit {
  view: any;
  disableCreate = false;
  constructor(
    private courseService: CourseService,
    private titleService: Title,
    private userService: UserService
  ) {}
  ngOnInit() {
    this.titleService.setTitle('Scaffold Home');
    this.userService
      .getRoleDetails()
      .pipe(take(1))
      .subscribe(user => {
        this.courseService.get(`users/homepage?mode=read`).subscribe(c => {
          if (c != null) {
            this.view = c;
          }
        });
      });
  }
}
